import { route } from 'preact-router'

interface Props {
	path: string
}
export function LegacyPartners({ path }: Props) {
	route(path.replace('/datapack-generator/partners/', '/datapack-generator/'))

	return null
}
